import React, { useState, useEffect } from 'react';
import DynamicSection from '../components/dynamic/DynamicSection';
import ProjectCard from '../components/ProjectCard';
import DynamicList from '../components/dynamic/DynamicList';
import DynamicButton from '../components/dynamic/DynamicButton';
import { projectsAPI } from '../services/api';
import { Project, Category } from '../types';

const Projects: React.FC = () => {
  const [projects, setProjects] = useState<Project[]>([]);
  const [filter, setFilter] = useState<string>('all');
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const loadProjects = async () => {
      try {
        const response = await projectsAPI.getAll();
        setProjects(response.data);
      } catch (error) {
        console.error('Error loading projects:', error);
      } finally {
        setLoading(false);
      }
    };
    loadProjects();
  }, []);

  const categories: Category[] = [
    { id: 'all', label: 'All Projects' },
    { id: 'fullstack', label: 'Full Stack' },
    { id: 'frontend', label: 'Frontend' },
    { id: 'backend', label: 'Backend' },
    { id: 'devops', label: 'DevOps' },
    { id: 'cloud', label: 'Cloud' },
    { id: 'ai', label: 'AI/ML' },
  ];

  const filteredProjects =
    filter === 'all'
      ? projects
      : projects.filter((project) => project.category === filter);

  if (loading) {
    return (
      <div className="pt-20 min-h-screen flex items-center justify-center bg-white dark:bg-gray-900">
        <div className="text-xl text-gray-600 dark:text-gray-400">Loading projects...</div>
      </div>
    );
  }

  return (
    <div className="pt-20">
      <DynamicSection
        title="My Projects"
        subtitle="A collection of my recent work and contributions"
        className="bg-white dark:bg-gray-900"
      >
        <div className="mb-8 flex flex-wrap justify-center gap-4">
          {categories.map((category) => (
            <DynamicButton
              key={category.id}
              onClick={() => setFilter(category.id)}
              variant={filter === category.id ? 'primary' : 'secondary'}
              size="md"
            >
              {category.label}
            </DynamicButton>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" style={{ overflow: 'visible' }}>
          {filteredProjects.map((project, index) => (
            <ProjectCard key={project.id} project={project} index={index} />
          ))}
          {filteredProjects.length === 0 && (
            <div className="col-span-full text-center py-12">
              <p className="text-gray-600 dark:text-gray-400">No projects found in this category.</p>
            </div>
          )}
        </div>
      </DynamicSection>
    </div>
  );
};

export default Projects;
